var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { Formik, Form, Field, FieldArray, ErrorMessage } from 'formik';
import { transformErrorToObject } from 'shared/error';
import Title from 'components/shared/Title';
import Loading from 'components/shared/Loading';
import Error from 'components/shared/Error';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  padding: 30px;\n\n  > .title {\n    width: 100%;\n    height: 85px;\n    margin-bottom: 50px;\n  }\n\n  > form {\n    > div {\n      width: 100%;\n      height: 50px;\n      line-height: 50px;\n      overflow: hidden;\n\n      &:not(:first-child) {\n        margin-top: 20px;\n      }\n\n      > div {\n        float: left;\n      }\n      \n      > .label {\n        width: 100px;\n\n        > label {\n          font-size: 18px;\n        }\n      }\n\n      > .input {\n        > input {\n          width: 400px;\n          height: 50px;\n          padding: 5px 10px;\n          font-size: 18px;\n        }\n      }\n    }\n\n    > .error {\n      height: 30px;\n      line-height: 30px;\n      color: red;\n      padding-left: 100px;\n    }\n\n    > button {\n      all: unset;\n      box-sizing: border-box;\n      width: 100px;\n      height: 50px;\n      margin-top: 30px;\n      text-align: center;\n      background: #36c;\n      color: #fff;\n      font-size: 16px;\n    }\n  }\n"], ["\n  width: 100%;\n  height: 100%;\n  padding: 30px;\n\n  > .title {\n    width: 100%;\n    height: 85px;\n    margin-bottom: 50px;\n  }\n\n  > form {\n    > div {\n      width: 100%;\n      height: 50px;\n      line-height: 50px;\n      overflow: hidden;\n\n      &:not(:first-child) {\n        margin-top: 20px;\n      }\n\n      > div {\n        float: left;\n      }\n      \n      > .label {\n        width: 100px;\n\n        > label {\n          font-size: 18px;\n        }\n      }\n\n      > .input {\n        > input {\n          width: 400px;\n          height: 50px;\n          padding: 5px 10px;\n          font-size: 18px;\n        }\n      }\n    }\n\n    > .error {\n      height: 30px;\n      line-height: 30px;\n      color: red;\n      padding-left: 100px;\n    }\n\n    > button {\n      all: unset;\n      box-sizing: border-box;\n      width: 100px;\n      height: 50px;\n      margin-top: 30px;\n      text-align: center;\n      background: #36c;\n      color: #fff;\n      font-size: 16px;\n    }\n  }\n"])));
var GET_INFO = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  query Project($projectName: String!) {\n    project(projectName: $projectName) {\n      id\n      contacts {\n        name\n        value\n        callable\n      }\n      address {\n        text\n        lat\n        lng\n      }\n    }\n  }\n"], ["\n  query Project($projectName: String!) {\n    project(projectName: $projectName) {\n      id\n      contacts {\n        name\n        value\n        callable\n      }\n      address {\n        text\n        lat\n        lng\n      }\n    }\n  }\n"])));
var UPDATE_INFO = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation UpdateInfo($info: ProjectInfoPayload!) {\n    updateProjectInfo(info: $info)\n  }\n"], ["\n  mutation UpdateInfo($info: ProjectInfoPayload!) {\n    updateProjectInfo(info: $info)\n  }\n"])));
export default (function (_a) {
    var project = _a.project;
    function submit(values, client) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, client.mutate({
                            mutation: UPDATE_INFO,
                            variables: { info: {
                                    contacts: values.contacts.map(function (contact) { return ({
                                        name: contact.name,
                                        value: contact.value,
                                        callable: contact.callable,
                                    }); }),
                                    address: {
                                        text: values.address.text,
                                        lat: values.address.lat,
                                        lng: values.address.lng,
                                    },
                                    projectName: project,
                                } }
                        })];
                    case 1:
                        _a.sent();
                        window.alert('수정이 완료되었습니다.');
                        return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement(Query, { query: GET_INFO, variables: { projectName: project } }, function (_a) {
        var loading = _a.loading, error = _a.error, data = _a.data, client = _a.client;
        if (loading)
            return React.createElement(Loading, null);
        if (error || !data.project)
            return React.createElement(Error, { error: error });
        var _b = data.project, contacts = _b.contacts, address = _b.address;
        return (React.createElement(Container, null,
            React.createElement("div", { className: "title" },
                React.createElement(Title, { title: '기본정보' })),
            React.createElement(Formik, { initialValues: { contacts: contacts, address: address }, onSubmit: function (values, actions) {
                    submit(values, client).then(function () {
                        actions.setSubmitting(false);
                    }, function (err) {
                        actions.setSubmitting(false);
                        actions.setErrors(transformErrorToObject(err));
                    });
                }, validate: function (values) {
                    var error = {};
                    values.contacts.some(function (contact) {
                        if (!contact.value) {
                            error.contacts = '반드시 모든 값이 있어야 합니다.';
                            return true;
                        }
                        return false;
                    });
                    if (!values.address.text || !values.address.lat || !values.address.lng) {
                        error.contacts = '반드시 모든 값이 있어야 합니다.';
                    }
                    return error;
                } }, function (_a) {
                var isSubmitting = _a.isSubmitting;
                return (React.createElement(Form, null,
                    React.createElement(FieldArray, { name: "contacts", render: function (_) { return contacts.map(function (contact, idx) {
                            var name = "contacts." + idx + ".value";
                            return (React.createElement("div", { key: idx },
                                React.createElement("div", { className: "label" },
                                    React.createElement("label", { htmlFor: name }, contact.name)),
                                React.createElement("div", { className: "input" },
                                    React.createElement(Field, { name: name }))));
                        }); } }),
                    React.createElement("div", null,
                        React.createElement("div", { className: "label" },
                            React.createElement("label", { htmlFor: "address.text" }, "\uC8FC\uC18C")),
                        React.createElement("div", { className: "input" },
                            React.createElement(Field, { name: "address.text" }))),
                    React.createElement("div", null,
                        React.createElement("div", { className: "label" },
                            React.createElement("label", { htmlFor: "address.lat" }, "\uC704\uB3C4")),
                        React.createElement("div", { className: "input" },
                            React.createElement(Field, { name: "address.lat" }))),
                    React.createElement("div", null,
                        React.createElement("div", { className: "label" },
                            React.createElement("label", { htmlFor: "address.lng" }, "\uACBD\uB3C4")),
                        React.createElement("div", { className: "input" },
                            React.createElement(Field, { name: "address.lng" }))),
                    React.createElement(ErrorMessage, { name: 'contacts', render: function (msg) { return React.createElement("div", { className: "error" }, msg); } }),
                    React.createElement("button", { type: "submit", disabled: isSubmitting }, "\uC218\uC815\uD558\uAE30")));
            })));
    }));
});
var templateObject_1, templateObject_2, templateObject_3;
